// Bouton "aléatoire" de la galerie, à gauche du plein écran. Non mémorisé :
// chaque visite repart en ordre chronologique.
export function initGalerieShuffleToggle({ shuffleBtn, galerieFeature }) {
  function updateButton() {
    const active = galerieFeature.isShuffleMode();
    shuffleBtn.classList.toggle('is-active', active);
    shuffleBtn.setAttribute('aria-pressed', String(active));
    shuffleBtn.title = active ? 'Revenir à l\'ordre chronologique' : 'Ordre aléatoire';
  }

  shuffleBtn.addEventListener('click', () => {
    galerieFeature.setShuffleMode(!galerieFeature.isShuffleMode());
    updateButton();
  });

  updateButton();
}
